import { render, staticRenderFns } from "./project-conversation-panel.vue?vue&type=template&id=61667c9e&scoped=true"
import script from "./project-conversation-panel.vue?vue&type=script&lang=js"
export * from "./project-conversation-panel.vue?vue&type=script&lang=js"
import style0 from "./project-conversation-panel.vue?vue&type=style&index=0&id=61667c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61667c9e",
  null
  
)

export default component.exports